import React, { useEffect, useState, useRef } from 'react';
import SEO from '../components/SEO';
import '../App.css';

function About() {
  const [counters, setCounters] = useState({
    doctors: 0,
    patients: 0,
    success: 0
  });
  const [hasAnimated, setHasAnimated] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const statsRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });

      // Check if stats section is visible
      if (statsRef.current && !hasAnimated) {
        const statsTop = statsRef.current.getBoundingClientRect().top;
        const statsVisible = window.innerHeight - 200;
        
        if (statsTop < statsVisible) {
          setHasAnimated(true);
          animateCounters();
        }
      }
    };

    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasAnimated]);

  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    document.body.style.overflow = 'hidden';
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeImageModal();
      }
    };

    if (selectedImage) {
      window.addEventListener('keydown', handleEscape);
      return () => window.removeEventListener('keydown', handleEscape);
    }
  }, [selectedImage]);

  const animateCounters = () => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;

      setCounters({
        doctors: Math.floor(4 * progress),
        patients: Math.floor(300 * progress),
        success: Math.floor(95 * progress)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
        setCounters({
          doctors: 4,
          patients: 300,
          success: 95
        });
      }
    }, stepDuration);
  };

  return (
    <div className="App">
      <SEO
        title="About Us - Best Nasha Mukti Kendra in Patna & Bihar | Nihansh Foundation"
        description="निहांश फाउंडेशन - Best Nasha Mukti in kendra Patna और Bihar। Our story, mission and vision for Nasha Mukti Kendra."
        path="/about"
      />
      {/* About Hero */}
      <section 
        className="page-hero about-hero"
        style={{
          backgroundImage: 'url(/images/Cigarette addiction.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          position: 'relative'
        }}
      >
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">हमारे बारे में</h1>
          <p className="page-hero-subtitle">नशामुक्त जीवन की ओर आपकी यात्रा में आपका साथी</p>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-image-wrapper animate-on-scroll">
              <img 
                src="/images/01.jpeg" 
                alt="About Nasha Mukti Kendra" 
                className="about-image" 
              />
              <div className="image-overlay"></div>
            </div>
            <div className="about-text animate-on-scroll">
              <h2 className="section-title">हमारी शुरुआत की कहानी – एक अनुभव जो ज़िंदगी बदल गया</h2>
              <p className="about-description">
                निहांश फाउंडेशन की शुरुआत किसी बिज़नेस प्लान या प्रॉफिट के इरादे से नहीं हुई। इसकी शुरुआत हुई एक ऐसे अनुभव से, जो मेरी ज़िंदगी का रुख ही बदल गया।
              </p>
              <p className="about-description">
                यह उस वक्त की बात है जब मैं अपनी कॉलेज ट्रेनिंग के दौरान एक नशा मुक्ति केंद्र में भेजा गया। मेरा उद्देश्य था वहाँ मरीज़ों के इलाज में मदद करना और उन पर रिसर्च करना। लेकिन जो मैंने वहाँ देखा, वह सिर्फ़ किताबों या सिलेबस का हिस्सा नहीं था — वह ज़िंदगी की सबसे कठोर सच्चाई थी।
              </p>
              <p className="about-description">
                रोज़ मैं ऐसे लोगों से मिलता था जो कभी किसी के बेटे थे, किसी के पिता, किसी के भाई और किसी के दोस्त। आज वही लोग नशे की लत में अपनी पहचान, अपना सम्मान और अपना भविष्य खो चुके थे।
              </p>
              <p className="about-description">
                कुछ मरीज़ शारीरिक रूप से बहुत कमज़ोर हो चुके थे, तो कुछ मानसिक रूप से पूरी तरह टूट चुके थे। उनकी आँखों में डर, अपराधबोध और लाचारी साफ़ दिखाई देती थी।
              </p>
            </div>
          </div>
          
          {/* Full Width Content Below */}
          <div className="about-full-content animate-on-scroll">
            <p className="about-description-full">
              सबसे ज़्यादा दर्द तब होता था जब मैं देखता था कि कई लोग नशा छोड़ना चाहते थे, लेकिन उनके पास न सही मार्गदर्शन था, न ही कोई ऐसा व्यक्ति जो उन्हें बिना जज किए समझ सके।
            </p>
            <p className="about-description-full">
              कुछ मरीज़ विदड्रॉल पेन से जूझ रहे थे, कुछ अपने परिवार से दूर हो चुके थे, और कुछ बस यह मान चुके थे कि अब उनकी ज़िंदगी कभी ठीक नहीं हो सकती।
            </p>
            <p className="about-description-full">
              उन पलों में मैंने यह समझा कि नशा सिर्फ़ एक आदत नहीं होता — यह एक ऐसी बीमारी है जो धीरे-धीरे व्यक्ति के शरीर, मन और रिश्तों को खोखला कर देती है।
            </p>
            <p className="about-description-full">
              उन लोगों की आँखों में उम्मीद की कमी और मदद की पुकार देखकर मेरी आँखें खुल गईं। उसी दिन मैंने अपने आप से यह वादा किया कि अगर मुझे मौका मिला, तो मैं अपनी ज़िंदगी लोगों को नशे से आज़ाद करने के लिए समर्पित कर दूँगा।
            </p>
            <p className="about-description-full">
              कॉलेज ट्रेनिंग के बाद भी वे तस्वीरें, वे चेहरे और वे कहानियाँ मेरे दिमाग़ से नहीं निकलीं। यहीं से निहांश फाउंडेशन का विचार जन्मा — एक ऐसा नशा मुक्ति केंद्र जहाँ मरीज़ को सिर्फ़ एक केस नहीं, बल्कि एक इंसान समझा जाए।
            </p>
            <p className="about-description-full">
              आज निहांश फाउंडेशन उसी सोच का नतीजा है — जहाँ हर व्यक्ति को सम्मान मिलता है, जहाँ गलतियों के लिए शर्मिंदा नहीं किया जाता, और जहाँ हर मरीज़ को एक नई शुरुआत का मौका दिया जाता है।
            </p>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats" ref={statsRef}>
        <div className="container">
          <h2 className="section-title">हमारी उपलब्धियां</h2>
          <div className="stats-grid">
            <div className="stat-card animate-on-scroll">
              <div className="stat-number">{counters.doctors}+</div>
              <div className="stat-label">प्रमाणित डॉक्टर</div>
            </div>
            <div className="stat-card animate-on-scroll">
              <div className="stat-number">{counters.patients}+</div>
              <div className="stat-label">खुश मरीज</div>
            </div>
            <div className="stat-card animate-on-scroll">
              <div className="stat-number">24/7</div>
              <div className="stat-label">सहायता उपलब्ध</div>
            </div>
            <div className="stat-card animate-on-scroll">
              <div className="stat-number">{counters.success}%</div>
              <div className="stat-label">सफलता दर</div>
            </div>
          </div>
        </div>
      </section>

{/* Founders Section */}
<section className="founders-section">
  <div className="container">
    <h2 className="section-title animate-on-scroll">हमारे संस्थापक</h2>
    <p className="section-subtitle animate-on-scroll">निहांश फाउंडेशन</p>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "30px"
      }}
    >
      <div
        className="founder-card"
        style={{
          width: "340px",
          border: "4px solid #2f5cff",
          borderRadius: "20px",
          padding: "20px",
          backgroundColor: "#fff",
          textAlign: "center"
        }}
      >
        <div
          style={{
            width: "100%",
            aspectRatio: "1 / 1",
            borderRadius: "16px",
            overflow: "hidden",
            marginBottom: "18px"
          }}
        >
          <img
            src="/mam.png"
            alt="Sanam Kumari"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center"
            }}
            onError={(e) => {
              e.target.src = "/images/banner-1.jpg";
            }}
          />
        </div>

        <h3
          style={{
            fontSize: "22px",
            fontWeight: "700",
            marginBottom: "6px"
          }}
        >
          Sanam Kumari
        </h3>

        <p
          style={{
            color: "#e53935",
            fontWeight: "600",
            fontSize: "15px"
          }}
        >
          संस्थापक, निहांश फाउंडेशन
        </p>
      </div>
    </div>
  </div>
</section>



      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          {/* Mission Section */}
          <div className="mission-vision-header">
            <div className="mission-icon-large animate-on-scroll">🎯</div>
            <h2 className="section-title mission-main-title animate-on-scroll">हमारा मिशन</h2>
            <p className="mission-vision-intro animate-on-scroll">
              निहांश फाउंडेशन का मिशन सिर्फ़ नशा छुड़ाना नहीं, बल्कि ज़िंदगी को दोबारा जीने लायक बनाना है। हम मानते हैं कि हर व्यक्ति, चाहे वह कितनी ही गहरी नशे की लत में क्यों न हो, अगर उसे सही समय पर सही सहारा मिले, तो वह अपनी ज़िंदगी बदल सकता है। हमारा मिशन उन लोगों के लिए एक उम्मीद की रोशनी बनना है, जो अपने आप को हार चुका महसूस करते हैं।
            </p>
          </div>

          <div className="mission-cards-grid">
            <div className="mission-card-item animate-on-scroll" style={{ animationDelay: '0.1s' }}>
              <div className="mission-card-icon">🏥</div>
              <h4 className="mission-card-title">संपूर्ण पुनर्वास</h4>
              <p className="mission-card-text">हम सिर्फ़ नशे को छुड़ाने पर ही फ़ोकस नहीं करते, बल्कि मरीज़ के शरीर, मन और सोच — तीनों पर काम करते हैं, ताकि रिकवरी लॉन्ग-टर्म और स्टेबल हो।</p>
            </div>

            <div className="mission-card-item animate-on-scroll" style={{ animationDelay: '0.2s' }}>
              <div className="mission-card-icon">👤</div>
              <h4 className="mission-card-title">पर्सनलाइज़्ड ट्रीटमेंट</h4>
              <p className="mission-card-text">हर व्यक्ति अलग होता है, इसलिए हमारा मिशन है कि हर मरीज़ के लिए उसकी कंडीशन, हिस्ट्री और मेंटल स्टेट के हिसाब से इंडिविजुअल ट्रीटमेंट प्लान बनाया जाए।</p>
            </div>

            <div className="mission-card-item animate-on-scroll" style={{ animationDelay: '0.3s' }}>
              <div className="mission-card-icon">🤝</div>
              <h4 className="mission-card-title">जज-फ्री एनवायरनमेंट</h4>
              <p className="mission-card-text">हमारा विश्वास है कि नशे की लत किसी की कमज़ोरी नहीं होती। इसलिए हमारा मिशन है एक ऐसा सेफ़ और नॉन-जजमेंटल एनवायरनमेंट देना, जहाँ मरीज़ खुलकर अपनी बात कह सके।</p>
            </div>

            <div className="mission-card-item animate-on-scroll" style={{ animationDelay: '0.4s' }}>
              <div className="mission-card-icon">👨‍👩‍👧‍👦</div>
              <h4 className="mission-card-title">परिवार का सहयोग</h4>
              <p className="mission-card-text">नशा सिर्फ़ एक व्यक्ति को नहीं, पूरे परिवार को प्रभावित करता है। इसलिए हमारा मिशन है कि ट्रीटमेंट के दौरान और बाद में फ़ैमिली काउंसलिंग और इमोशनल सपोर्ट दिया जाए।</p>
            </div>

            <div className="mission-card-item animate-on-scroll" style={{ animationDelay: '0.5s' }}>
              <div className="mission-card-icon">🛡️</div>
              <h4 className="mission-card-title">लॉन्ग-टर्म सपोर्ट</h4>
              <p className="mission-card-text">हम चाहते हैं कि मरीज़ ट्रीटमेंट के बाद भी अकेला महसूस न करे। हमारा मिशन है रिलैप्स प्रिवेंशन, फ़ॉलो-अप और कंटीन्यूअस गाइडेंस के ज़रिए मरीज़ को नशे से दूर रखना।</p>
            </div>

            <div className="mission-card-item animate-on-scroll" style={{ animationDelay: '0.6s' }}>
              <div className="mission-card-icon">📢</div>
              <h4 className="mission-card-title">जागरूकता फैलाना</h4>
              <p className="mission-card-text">हमारा मिशन सिर्फ़ एक नशा मुक्ति केंद्र तक सीमित नहीं है। हम चाहते हैं कि समाज नशे को शर्म की नज़र से नहीं, बल्कि इलाज और संवेदना की नज़र से देखे।</p>
            </div>
          </div>

          <div className="mission-belief-box animate-on-scroll">
            <div className="belief-icon">💫</div>
            <h3 className="belief-title">हमारा विश्वास</h3>
            <p className="belief-quote">"हर इंसान सुधर सकता है, बस उसे सही रास्ता और सही हाथ की ज़रूरत होती है।"</p>
            <p className="belief-text">निहांश फाउंडेशन का मिशन इसी विश्वास पर टिका है — लोगों को नशे से आज़ाद करके उन्हें एक स्वस्थ, सम्मानजनक और सकारात्मक जीवन देना। हम सिर्फ़ इलाज नहीं करते, हम ज़िंदगी दोबारा बनाना सिखाते हैं।</p>
          </div>

          {/* Vision Section */}
          <div className="mission-vision-header vision-header">
            <div className="mission-icon-large animate-on-scroll">👁️</div>
            <h2 className="section-title mission-main-title animate-on-scroll">हमारा विज़न</h2>
            <p className="mission-vision-intro animate-on-scroll">
              निहांश फाउंडेशन का विज़न एक ऐसे समाज का निर्माण करना है जहाँ नशा एक शर्म का विषय नहीं, बल्कि एक बीमारी समझी जाए — जिसका इलाज संभव हो, बिना नफ़रत, बिना जज किए और बिना भेदभाव के। हम एक ऐसा भविष्य देखते हैं जहाँ कोई भी व्यक्ति नशे की वजह से अपनी पहचान, अपना सम्मान और अपनी उम्मीद न खोए।
            </p>
          </div>

          <div className="mission-cards-grid">
            <div className="mission-card-item vision-card animate-on-scroll" style={{ animationDelay: '0.1s' }}>
              <div className="mission-card-icon">🌍</div>
              <h4 className="mission-card-title">नशा-मुक्त समाज</h4>
              <p className="mission-card-text">हम चाहते हैं कि हर शहर, हर गाँव और हर परिवार में नशे के ख़िलाफ़ जागरूकता हो और लोग समझें कि नशा मुक्ति मुमकिन है।</p>
            </div>

            <div className="mission-card-item vision-card animate-on-scroll" style={{ animationDelay: '0.2s' }}>
              <div className="mission-card-icon">🔄</div>
              <h4 className="mission-card-title">सुधार का मौका</h4>
              <p className="mission-card-text">हमारा विज़न है एक ऐसा सिस्टम बनाना जहाँ हर व्यक्ति, चाहे वह कितनी भी गलतियाँ कर चुका हो, उसे दोबारा शुरुआत का मौका मिले।</p>
            </div>

            <div className="mission-card-item vision-card animate-on-scroll" style={{ animationDelay: '0.3s' }}>
              <div className="mission-card-icon">❤️</div>
              <h4 className="mission-card-title">करुणा और सम्मान</h4>
              <p className="mission-card-text">हम एक ऐसे हेल्थकेयर और रीहैबिलिटेशन मॉडल का सपना देखते हैं जहाँ मरीज़ को दबाव या डर से नहीं, बल्कि प्यार, संवेदना और सम्मान के साथ ठीक किया जाए।</p>
            </div>

            <div className="mission-card-item vision-card animate-on-scroll" style={{ animationDelay: '0.4s' }}>
              <div className="mission-card-icon">🤲</div>
              <h4 className="mission-card-title">समाज का सहयोग</h4>
              <p className="mission-card-text">हमारा विज़न सिर्फ़ मरीज़ तक सीमित नहीं है। हम चाहते हैं कि परिवार, दोस्त और समाज मिलकर रिकवरी का हिस्सा बनें।</p>
            </div>

            <div className="mission-card-item vision-card animate-on-scroll" style={{ animationDelay: '0.5s' }}>
              <div className="mission-card-icon">⭐</div>
              <h4 className="mission-card-title">भरोसे का प्रतीक</h4>
              <p className="mission-card-text">हम चाहते हैं कि जब भी कोई "नशा मुक्ति केंद्र" का नाम सुने, तो उसके मन में डर नहीं, बल्कि भरोसा और उम्मीद आए।</p>
            </div>
          </div>

          <div className="mission-belief-box vision-belief-box animate-on-scroll">
            <div className="belief-icon">✨</div>
            <h3 className="belief-title">हमारा सपना</h3>
            <p className="belief-quote">"ऐसी दुनिया बनाना जहाँ हर व्यक्ति को नशे से नहीं, अपनी ज़िंदगी से पहचाना जाए।"</p>
            <p className="belief-text">निहांश फाउंडेशन का विज़न सिर्फ़ आज के लिए नहीं, बल्कि आने वाली पीढ़ियों के लिए है — ताकि वे एक स्वस्थ, सकारात्मक और नशा-मुक्त भविष्य देख सकें। हम चाहते हैं कि निहांश फाउंडेशन एक संस्था नहीं, बल्कि एक आंदोलन बने — जो ज़िंदगियाँ बचाए, परिवार जोड़े और उम्मीद को ज़िंदा रखे।</p>
          </div>
        </div>
      </section>

 {/* Activities Gallery Section */}
<section
  className="about-activities-gallery"
  style={{ marginBottom: "40px" }}   // 👈 halka space added
>
  <div className="container">
    <h2 className="section-title animate-on-scroll">हमारी गतिविधियाँ</h2>
    <p className="section-subtitle animate-on-scroll">
      निहांश फाउंडेशन के विभिन्न कार्यक्रम और गतिविधियाँ
    </p>

    <div className="gallery-grid">
      {[
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-01.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-03.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-04.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-06.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-07.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-08.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-09.jpeg',
        '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-10.jpeg'
      ].map((image, index) => (
        <div
          key={index}
          className="gallery-item animate-on-scroll"
          style={{ animationDelay: `${index * 0.05}s` }}
          onClick={() => openImageModal(image)}
        >
          <img
            src={image}
            alt={`Nihansh Foundation Activity ${index + 1}`}
            className="gallery-image"
            loading="lazy"
            style={{ display: 'block', width: '100%', height: '100%' }}
            onError={(e) => {
              console.error('Image failed to load:', image);
              e.target.style.display = 'none';
            }}
            onLoad={(e) => {
              e.target.style.opacity = '1';
              e.target.style.display = 'block';
            }}
          />
          <div className="gallery-overlay">
            <span className="gallery-icon">🔍</span>
          </div>
        </div>
      ))}
    </div>

    {/* 👇 Light spacer instead of "aur dekhe" button */}
    <div style={{ height: "20px" }}></div>
  </div>
</section>



      {/* Image Modal/Popup */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal-close" onClick={closeImageModal}>×</button>
            <img src={selectedImage} alt="Gallery" className="image-modal-image" />
          </div>
        </div>
      )}
    </div>
  );
}

export default About;

